import { ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, groupBy, map, mergeMap, startWith, throttleTime } from 'rxjs/operators';
import { requestActions } from '../apiHelpers';
import { ID, ReduxAction, UserSession } from '@repo/utils/types';
import { apiObservable } from '@repo/utils/helpers/api';

/* Epic actions */
const sharedContactSourcesActions = requestActions('SHARED_CONTACT_SOURCES', ['fetch']);

/* Component actions */
export const fetchSharedContactSources = (contactUUID: ID, user: UserSession | null) =>
  sharedContactSourcesActions['fetch']({ contactUUID, authenticatedUser: !!user });

/* Epics */
const fetchSharedContactSourcesEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('FETCH_SHARED_CONTACT_SOURCES'),
    groupBy(({ payload }) => payload.contactUUID),
    mergeMap((fetchesByUUID) =>
      fetchesByUUID.pipe(
        throttleTime(1000 * 60 * 1),
        mergeMap(({ payload }) =>
          apiObservable('GET', `/shared-contact/${payload.contactUUID}/contact-info/`, undefined, {
            noAuthorization: !payload.authenticatedUser,
            apiVersion: 'v2',
          }).pipe(
            map(({ response }) =>
              sharedContactSourcesActions['fetchSucceeded']({
                response,
                contactUUID: payload.contactUUID,
              }),
            ),
            startWith(
              sharedContactSourcesActions['fetchRequested']({ contactUUID: payload.contactUUID }),
            ),
            catchError((err) =>
              of(
                sharedContactSourcesActions['fetchFailed']({
                  ...err,
                  contactUUID: payload.contactUUID,
                }),
              ),
            ),
          ),
        ),
      ),
    ),
  );

export const sharedSourcesEpic = fetchSharedContactSourcesEpic;
